import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { Footer } from './Footer';
interface PortalShellProps {
  children: React.ReactNode;
}
export function PortalShell({
  children
}: PortalShellProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <div className="min-h-screen bg-background" data-id="element-90" data-mp="3c6nc3mzsgv4j">
      <Sidebar isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} data-id="element-91" data-mp="3c39dmpu8x62d" />
      <div className="lg:pl-72 flex flex-col min-h-screen" data-id="element-92" data-mp="3m3s2jz0o3cr5">
        <TopBar onOpenMenu={() => setIsMobileMenuOpen(true)} data-id="element-93" data-mp="3m275a1myxfpl" />
        <main className="flex-1 py-6 px-4 sm:py-10 sm:px-6 lg:px-8" data-id="element-94" data-mp="3qu8fli0kswcz">
          {children}
        </main>
        <Footer data-id="element-95" data-mp="3vtuwq2jiywr2" />
      </div>
    </div>;
}